import { render, staticRenderFns } from "./FoodPocket.vue?vue&type=template&id=e638c648&scoped=true&"
import script from "./FoodPocket.vue?vue&type=script&lang=js&"
export * from "./FoodPocket.vue?vue&type=script&lang=js&"
import style0 from "./FoodPocket.vue?vue&type=style&index=0&id=e638c648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e638c648",
  null
  
)

export default component.exports